"use client";

import { useRouter } from "next/navigation";
import { Wallet } from "lucide-react";
import { useRemoteData, DATA_KEYS } from "@/utils/useRemoteData";
import { usePermissions } from "@/hooks/usePermissions";
import { ORG_PERMISSIONS } from "@/constants/permissions";
import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/shadcn/sidebar";
import { EntryIcon, EntryLabel } from "./SideNavEntry";

export const UpgradeSection = () => {
  const router = useRouter();
  const { hasPermission } = usePermissions();
  const canManageBilling = hasPermission(ORG_PERMISSIONS.ORG.BILLING, "tenant");
  const { data } = useRemoteData(DATA_KEYS.BILLING, undefined, {
    enabled: canManageBilling,
  });
  if (!canManageBilling || !data?.over_limit_metrics?.length) return null;
  return (
    <SidebarMenuItem className="list-none">
      <SidebarMenuButton
        onClick={() => router.push("/settings/administration/billing")}
        className="group/menu-button"
      >
        <EntryIcon icon={Wallet} />
        <EntryLabel>Review billing</EntryLabel>
        <span className="ml-auto size-1.5 shrink-0 rounded-full bg-warning-500 group-data-[collapsible=icon]:hidden" />
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
